module.exports = "/dist/index.css";